(function () {
"use strict";
const config = document.querySelector("[data-vd-scene-assets]");
function init() {
 // The Liquid allowlist loads this script only for general text products.
 const root = document.querySelector('[data-vd-decal-designer]');
 if (!root || root.dataset.scenePilot || !config) return;
 const panel = root.querySelector(".vd-decal__preview-panel"), original = root.querySelector(".vd-decal__preview"), source = root.querySelector("[data-vd-preview-path]"), art = root.querySelector("[data-vd-preview]");
 if (!panel || !original || !source || !art) return;
 root.dataset.scenePilot = "photo-adaptive-v6";
 const memorial = root.dataset.productHandle === "ilm-text";
 const scenes = memorial ? [
  {name:"Artwork",caption:"Your exact artwork"},
  {name:"Side window close-up",key:"windowclose",box:[150,330,650,300],inches:12,ink:"#ffffff"},
  {name:"Car rear window",key:"window",box:[160,340,680,220],inches:42,ink:"#ffffff"},
  {name:"Interior wall",key:"wall",close:true,box:[225,200,550,340],inches:72,ink:"#202020"}
 ] : [
  {name:"Artwork", caption:"Your exact artwork · click a word to edit"},
  {name:"Water bottle", key:"bottle", rotate:true, box:[362,260,250,580], inches:3, ink:"#171717"},
  {name:"Interior wall", key:"wall", close:true, box:[225,200,550,340], inches:72, ink:"#202020"},
  {name:"Mailbox", key:"mailbox", clean:true, box:[235,370,535,180], inches:14, ink:"#ffffff"},
  {name:"Car rear window", key:"window", clean:true, close:true, box:[300,350,400,175], inches:24, ink:"#ffffff"},
  {name:"Vehicle surface", key:"vehicle", close:true, box:[265,415,490,250], inches:24, ink:"#171717"},
  {name:"Storefront window", key:"storefront", minimum:36, box:[110,245,760,390], inches:180, ink:"#ffffff"},
  {name:"Semi-trailer", key:"semi", minimum:36, box:[110,240,830,240], inches:240, ink:"#171717"},
  {name:"Boat hull", key:"boat", box:[150,440,650,200], inches:40, ink:"#171717"},
  {name:"Drum head", key:"drum", box:[130,90,740,740], inches:22, circle:21, ink:"#171717"}
 ];
 let index = 0;
 const frame = document.createElement("div"); frame.className = "vd-scenes__frame";
 original.before(frame); frame.append(original);
 const mock = document.createElement("div"); mock.className = "vd-scenes__stage"; mock.hidden = true; frame.append(mock);
 const nav = document.createElement("div"); nav.className = "vd-scenes__nav";
 nav.innerHTML = '<button type="button" data-scene-prev aria-label="Previous preview background"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></button><button type="button" data-scene-next aria-label="Next preview background"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg></button>';
 frame.append(nav);
 const foot = document.createElement("div"); foot.className = "vd-scenes__foot";
 foot.innerHTML = "<span data-scene-label aria-live=\"polite\"></span><div class=\"vd-scenes__dots\"></div><p data-scene-caption></p><button type=\"button\" data-scene-edit hidden>Back to artwork</button><small data-scene-disclaimer hidden>Example placement. Actual surfaces vary - measure yours before ordering. Contrasting preview ink is not a vinyl color proof.</small>";
 frame.after(foot);
 const dimension = root.querySelector(".vd-decal__dimension-line");
 original.append(dimension);
 original.style.position = "relative";
 dimension.classList.add("vd-scenes__art-dimension");
 function placeDimension() {
  if (index) return;
  const b=source.getBoundingClientRect(), o=original.getBoundingClientRect();
  dimension.style.top=Math.min(o.height-40,b.bottom-o.top+18)+"px";
  dimension.style.left=Math.max(16,b.left-o.left)+"px";
  dimension.style.width=Math.min(o.width-32,b.width)+"px";
 }
 new ResizeObserver(placeDimension).observe(original);

 const dots = foot.querySelector(".vd-scenes__dots");
 scenes.forEach((s,i) => { const b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-label", i ? "Preview on " + s.name : "Show plain artwork"); b.addEventListener("click", () => { index = i; draw(); }); dots.append(b); });
 function size() {
  return {w:parseFloat(root.querySelector("[data-vd-summary-width]").textContent),h:parseFloat(root.querySelector("[data-vd-summary-height]").textContent)};
 }
 function resolved(s) {
  const d=size();
  if(s.closeup||!s.close||d.w>12||d.h>5)return s;
  const keys={wall:"wallclose",window:"windowclose",vehicle:"truckclose"};
  return {...s,key:keys[s.key]||s.key,box:[150,330,650,300],inches:12,closeup:true};
 }
 function layout(s) {
  s=resolved(s);
  if(!s.key)return {};
  const d=size(), [bx,by,bw,bh]=s.box, unit=bw/s.inches;
  if(!(d.w>0&&d.h>0)||s.minimum&&d.w<s.minimum)return null;
  // Keep every corner inside the example drum's rim, with half-inch radial clearance.
  if(s.circle&&Math.hypot(d.w,d.h)>s.circle)return null;
  const normal=d.w*unit<=bw+.01&&d.h*unit<=bh+.01;
  const rotate=!normal&&s.rotate&&d.h*unit<=bw+.01&&d.w*unit<=bh+.01;
  if(!normal&&!rotate)return null;
  return {w:d.w*unit,h:d.h*unit,rotate,unit};
 }
 function available(){return scenes.map((s,i)=>layout(s)?i:-1).filter(i=>i>=0);}
 function sync() {
  placeDimension();
  const allowed=available();
  dots.querySelectorAll("button").forEach((b,i)=>{b.hidden=!allowed.includes(i);});
  nav.hidden=allowed.length<2;
  if(!allowed.includes(index)){index=0;draw();return;}
  const s=resolved(scenes[index]), dest=mock.querySelector("[data-scene-art]");
  foot.querySelector("[data-scene-label]").textContent=s.name+" · "+(allowed.indexOf(index)+1)+" / "+allowed.length;
  if(!index||!dest)return;
  const photo=mock.querySelector("img");
  if(photo.dataset.sceneKey!==s.key){photo.dataset.sceneKey=s.key;photo.src=config.dataset[s.key];}
  const l=layout(s), d=size(), [bx,by,bw,bh]=s.box;
  mock.dataset.fits="true";mock.dataset.rotated=String(!!l.rotate);
  const badge=mock.querySelector("[data-scene-measurements]");
  badge.hidden=!!s.clean;
  badge.textContent=(memorial?'Length ':'Width ')+d.w.toFixed(3)+'″ × Height '+d.h.toFixed(3)+'″';
 const mixed=root.querySelector('[data-vd-mixed-layer]');
 if(mixed){
  dest.replaceChildren(...Array.from(mixed.children).map(node=>node.cloneNode(true)));
  // A cloned clip must never resolve to the hidden original artwork's ID.
  const ids=new Map();dest.querySelectorAll('[id]').forEach(node=>{const old=node.id,next=old+'-scene';ids.set(old,next);node.id=next;});
  dest.querySelectorAll('*').forEach(node=>{for(const attribute of Array.from(node.attributes)){let value=attribute.value;ids.forEach((next,old)=>{value=value.split('url(#'+old+')').join('url(#'+next+')');});if(value!==attribute.value)node.setAttribute(attribute.name,value);}});
  if(dest.lastElementChild)dest.lastElementChild.setAttribute('fill',s.ink);
 }
 // Mixed artwork is authored in finished inches. getBBox on the hidden
 // original is browser-dependent and can return zero or unrelated units.
 if(!mixed)dest.querySelector('path').setAttribute('d',source.getAttribute('d')||'');
 const bounds=mixed?{x:0,y:0,width:d.w,height:d.h}:art.viewBox.baseVal;if(!bounds.width||!bounds.height)return;
  dest.setAttribute("viewBox",[bounds.x,bounds.y,bounds.width,bounds.height].join(" "));
  dest.setAttribute("preserveAspectRatio","none");
  let cx=bx+bw/2,cy=by+bh/2;
  const close=!!s.closeup;
  dest.setAttribute("x",cx-l.w/2);dest.setAttribute("y",cy-l.h/2);
  dest.setAttribute("width",l.w);dest.setAttribute("height",l.h);
  dest.setAttribute("transform",l.rotate?'rotate(-90 '+cx+' '+cy+')':'');
  mock.querySelector(".vd-scenes__camera").style.transform="none";
  mock.dataset.closeup=String(close);
  foot.querySelector("[data-scene-caption]").textContent=close?"Close-up view":l.rotate?"Vertical placement":"";
 }
 function draw() {
  const allowed=available();if(!allowed.includes(index))index=0;
  const s=scenes[index];
  original.hidden=!!index;original.style.display=index?"none":"";
  mock.hidden=!index;
  foot.querySelector("[data-scene-edit]").hidden=!index;
  foot.querySelector("[data-scene-disclaimer]").hidden=!index;
  foot.querySelector("[data-scene-caption]").textContent=index?"":"Use the arrows to try it on a surface";
  dots.querySelectorAll("button").forEach((b,i)=>b.setAttribute("aria-pressed",String(i===index)));
  if(index){
   mock.innerHTML='<div class="vd-scenes__measurements" data-scene-measurements></div><div class="vd-scenes__camera"><img alt="" width="1254" height="1254" decoding="async"><svg viewBox="0 0 1000 1000" role="img" aria-label="Your decal on '+s.name+'"><svg data-scene-art><path fill="'+s.ink+'"/></svg></svg></div>';
   const photo=mock.querySelector("img");
   photo.addEventListener("error",()=>{if(scenes[index]===s){index=0;draw();}},{once:true});
   photo.dataset.sceneKey="";
  }
  sync();
 }
 function step(direction){const a=available();index=a[(a.indexOf(index)+direction+a.length)%a.length];draw();}
 nav.querySelector("[data-scene-prev]").addEventListener("click",()=>step(-1));
 nav.querySelector("[data-scene-next]").addEventListener("click",()=>step(1));
 foot.querySelector("[data-scene-edit]").addEventListener("click", () => { index = 0; draw(); });
 new MutationObserver(sync).observe(art, {attributes:true, subtree:true, attributeFilter:["d","viewBox"]});
 root.addEventListener('vd-mixed-render',sync);
 new MutationObserver(sync).observe(root.querySelector("[data-vd-summary-width]"), {childList:true,subtree:true,characterData:true});
 new MutationObserver(sync).observe(root.querySelector("[data-vd-summary-height]"), {childList:true,subtree:true,characterData:true});
 draw();
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
